import React from 'react';
import moment from 'moment';

export default class AccrualByPlacement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isElementVisible: [],

        }
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.expandApprover = this.expandApprover.bind(this);
    }

    toggleVisibility(index) {
        let isElementVisible = this.state.isElementVisible.slice(0);
        isElementVisible[index] = !isElementVisible[index];
        this.setState({ isElementVisible });
    }
    
    expandApprover(approverId) {
        if (this.props.onExpandApprover)
            this.props.onExpandApprover(approverId);
    }

    render() {
        let list = this.props.items;
        let content = [];
        for (let i = 0, rowNo = 0; i < list.length; i++) {
            let item = list[i];
                
            let accruals = item.accrualSummaryList;
            if (accruals == null || accruals.length == 0) {
                content.push(
                    <div className={`row ap-accrualgrid-detail-${i%2}`} key={`${i}_0`}>
                        {   item.approverId?
                                [<div key="col_0" className="col-md-2 text-left ap-text-bold" title={item.placement.fullName}>
                                    {item.placement.fullName}
                                </div>,
                                <div key="col_1" className="col-md-1 text-right ap-text-bold">
                                    <a href="#" onClick={() => this.expandApprover(item.approverId)}>{`${item.employeeCount} Staff`}</a>
                                </div>,
                                <div key="col_2" className="col-md-9">
                                </div>]
                                :
                                [<div key="col_0" className="col-md-12 text-left ap-text-bold">
                                    {item.placement.fullName}
                                </div>]
                        }
                    </div>
                );
                rowNo++;
                continue;
            }

            for (let j = 0; j < accruals.length; j++) {
                let idx = rowNo;
                let summary = accruals[j];
                const showAccruedHrs = (summary.isVisibleToUser === true);

                content.push(
                    <div className={`row ap-accrualgrid-detail-${i%2}`} key={`${i}_${j}`}>
                        <div className="col-md-12">
                            <div className="row">
                                {   item.approverId?
                                        [<div key="col_0" className="col-md-2 text-left ap-text-bold" title={j == 0 ? item.placement.fullName : ""}>
                                            {j == 0 ? item.placement.fullName : ""}
                                        </div>,
                                        <div key="col_1" className="col-md-1 text-right ap-text-bold">
                                            {j == 0 ? <a href="#" onClick={() => this.expandApprover(item.approverId)}>{`${item.employeeCount} Staff`}</a> : null}
                                        </div>]
                                        :
                                        [<div key="col_0" className="col-md-3 text-left ap-text-bold" title={j == 0 ? item.placement.fullName : ""}>
                                            {j == 0 ? item.placement.fullName : ""}
                                        </div>]
                                }
                                <div className="col-md-3 text-left">
                                    <span onClick={() => this.toggleVisibility(idx)} className={this.state.isElementVisible[idx] ? "fa fa-minus-square-o ap-good-color ap-pointer" : " fa fa-plus-square-o ap-good-color ap-pointer"}> </span>&nbsp;
                                    {summary.accrualDescription}
                                </div>
                                <div className="col-md-2">
                                    {showAccruedHrs ? summary.totalAccruedHours : ""}
                                </div>
                                <div className="col-md-2">
                                    {summary.loggedHours}
                                </div>
                                <div className="col-md-2">
                                    {showAccruedHrs ? summary.availableHours : ""}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 text-left ap-unwrap-content">
                                    {j == 0 ? 
                                        `(Anniversary Day: ${moment(summary.leaveYearEndDate).add("d", 1).format("MMM D, YYYY")})` : <br/>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-8 col-md-offset-3">
                                    {this.state.isElementVisible[idx] ?
                                        <AccrualLogRow accrualLogs={summary.accrualLogs} group={summary.accrualDescription} /> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                );
                rowNo++;
            }
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="container-fluid ap-accrualgrid-header">
                            <div className="row">
                                <div className="col-md-3">
                                    Employee
                                </div>
                                <div className="col-md-3">
                                </div>
                                <div className="col-md-2">
                                    Total Accrued Hours
                                </div>
                                <div className="col-md-2">
                                    Logged Hours
                                </div>
                                <div className="col-md-2">
                                    Available Hours
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="container-fluid ap-accrualgrid">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
class AccrualLogRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        const accrualLogs = this.props.accrualLogs
        const group = this.props.group;
        let counter = 0;
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="col-md-2">
                        Date
                    </div>
                    <div className="col-md-2">
                        Hours Logged
                    </div>
                    <div className="col-md-2">
                        Status
                    </div>
                    <div className="col-md-6">
                        Comments
                    </div>
                </div>
                <br />
                {accrualLogs
                    .sort((a, b) => new Date(b.fromDate).getTime() - new Date(a.fromDate).getTime())
                    .map(item => {
                    return (
                        <div className="col-md-12" key={group + '_' + counter++}>
                            <div className="col-md-2">
                                {moment(item.fromDate).format('MM/DD/YYYY')}
                            </div>
                            <div className="col-md-2">
                                {item.loggedHours}
                            </div>
                            <div className="col-md-2">
                                {item.pending == "Y" ? "Pending" : "Processed"}
                            </div>
                            <div className="col-md-6">
                                {item.comment}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
